//--------------------------------------------------------------------- 
// Important 
// 
// Copyright in this document remains the property of RAPP Limited 
// and this document may not be reproduced in whole or part without 
// our prior written consent.
// All information of whatever nature contained in this document is
// strictly confidential and may not be used, implemented, adapted or 
// communicated to any third party without the consent of RAPP Limited.
// 
//---------------------------------------------------------------------
// Module . . : testdrive.reqasterisk.js   
// System . . : Test Drive
// Author . . : Neil Weaver 
// Date . . . : March 2017
//---------------------------------------------------------------------
// Description
// outputs an asterisk on the label of all mandatory fields
// Also bypasses adding of asterisk where shoudln't be one but default behaviour of certain controls like select
// appear to automatically add them (ie.e [Required] is not explicitly declared) i.e. data-val-required class is present.
// to get round this a new class noasterisk needs to be added into the html to prevent adding in of the asterisk.
// e.g. @Html.DropDownListFor(x => x.MinutesPrepTime, new SelectList(Model.DefaultPrepTimeList, "Value", "Text", Model.MinutesPrepTime), new {@class = "form-control travelorprep noasterisk" })
//
//---------------------------------------------------------------------
// Change         Date        Amended by /
// Control        DD/MM/YY    Description
// -------        --------    -------------
//
//---------------------------------------------------------------------*/

var labelForConst = 'label[for="';

	jQuery(document).ready(function ($) {

        $('input[type=text]').each(function () {
            handleInputField($(this));

            handleInputFieldIf($(this));
        });

        $('input[type=number]').each(function () {
            handleInputField($(this));

            handleInputFieldIf($(this));
        });

		$('.editor-field select').each(function () {
            handleSelect(this);

            handleSelectIf(this);
		});

        $('textarea').each(function() {
            handleInputField($(this));

            handleInputFieldIf($(this));
        });

        handleAddasteriskClass();
    });

function handleAddasteriskClass() {
	$('.addasterisk').each(function () {
        var label = $(this);
        var text = label.text();
		if (text.length > 0) {
			var span = label.find('span[style="color:red"');
            span.remove();
            label.append('<span style="color:red" title="' + text + ' is mandatory"> *</span>');
        }
    });
}

function handleAddasteriskClassForDiv(div) {
    $('#'+ div +' .addasterisk').each(function () {
        var label = $(this);
        var text = label.text();
        if (text.length > 0) {
            var span = label.find('span[style="color:red"');
            span.remove();
            label.append('<span style="color:red" title="' + text + ' is mandatory"> *</span>');
        }
    });
}


function handleInputField(elem) {
    var req = elem.attr('data-val-required');
    var readOnly = elem.attr('readOnly');
    var disabled = elem.attr('disabled');
    if (undefined != req && readOnly != 'readonly' && disabled != 'disabled') {
        var label = $(labelForConst + elem.attr('id') + '"]');
        var text = label.text();
        if (text.length > 0) {
            label.append('<span style="color:red" title="' + text + ' is mandatory"> *</span>');
        }
    }
}

function handleInputFieldIf(elem) {
    var req = elem.attr('data-val-requiredif-isrequired');
    var readOnly = elem.attr('readOnly');
    var disabled = elem.attr('disabled');
    if (undefined !== req && readOnly !== 'readonly' && disabled !== 'disabled' && req === 'true') {
        var label = $(labelForConst + elem.attr('id') + '"]');
        var text = label.text();
        if (text.length > 0) {
            label.append('<span style="color:red" title="' + text + ' is mandatory"> *</span>');
        }
    }
}

function handleSelect(elem) {
    var req = $(elem).attr('data-val-required');
    var outerhtml = elem.outerHTML;
    if (outerhtml.indexOf("noasterisk") >= 0) {
        return;
    }
    if (undefined != req) {
        var label = $(labelForConst + $(elem).attr('id') + '"]');
        var text = label.text();
        if (text.length > 0) {
            label.append('<span style="color:red" title="' + text + ' is mandatory"> *</span>');
        }
    }
}

function handleSelectIf(elem) {
    var req = $(elem).attr('data-val-requiredif-isrequired');
    var outerhtml = elem.outerHTML;
    if (outerhtml.indexOf("noasterisk") >= 0) {
        return;
    }
    if (undefined !== req && req === 'true') {
        var label = $(labelForConst + $(elem).attr('id') + '"]');
        var text = label.text();
        if (text.length > 0) {
            label.append('<span style="color:red" title="' + text + ' is mandatory"> *</span>');
        }
    }
}